// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  calendar: getIcon('ic_calendar'),
  kanban: getIcon('ic_kanban'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'Général',
    items: [
      { title: 'Questions', path: '/dashboard/questions', icon: ICONS.dashboard },
      { title: 'Catégories', path: '/dashboard/categories', icon: ICONS.ecommerce },
      { title: 'Challenge Journalier', path: '/dashboard/challenge', icon: ICONS.calendar },
      { title: 'Meilleurs Scores', path: '/dashboard/scores', icon: ICONS.analytics },
      { title: 'Correction Textes', path: '/dashboard/corrections', icon: ICONS.kanban },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'Gestion',
    items: [
      {
        title: 'user',
        path: '/dashboard/user',
        icon: ICONS.user,
        children: [
          { title: 'Admin', path: '/dashboard/user/admin' },
          { title: 'Mon Compte', path: '/dashboard/user/me' },
        ],
      },
    ],
  },
];

export default navConfig;
